import { createRoot } from 'react-dom/client'
import { useState } from 'react'
import { LoginScreen } from './components/LoginScreen'
import { SuccessScreen } from './components/Success'
import { Viewpager } from './components/Viewpager'
import { SwipeHint } from './components/SwipeHint'

export default function App() {
  const [appState, setAppState] = useState('login')

  const handleLoginSuccess = () => {
    setAppState('success')
    setTimeout(() => {
      setAppState('viewpager')
    }, 3000)
  }

  return (
    <div
      className="app-shell"
      style={{
        position: 'relative'
      }}>
      <div className="phone-frame">
        {appState === 'login' && <LoginScreen onSuccess={handleLoginSuccess} />}
        {appState === 'success' && <SuccessScreen />}
        {appState === 'viewpager' && (
          <>
            <Viewpager />
            <SwipeHint />
          </>
        )}
      </div>
    </div>
  )
}

const root = createRoot(document.getElementById('root'))
root.render(<App />)
